import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { SharedModule } from '../../../shared/shared.module';
import { AgencyAuditService, AuditEntry } from '../../../services/agency-audit.service';
import { FlagService } from '../../../shared/services/flag.service';
import { FlagType } from '../../../shared/utils/enums';

/** "Journal d'audit" — who did what and when (route guarded by AUDIT_VIEW). */
@Component({
  selector: 'app-audit-log',
  standalone: true,
  imports: [CommonModule, FormsModule, MatPaginatorModule, MatSelectModule, SharedModule],
  templateUrl: './audit-log.component.html',
  styleUrl: './audit-log.component.scss',
})
export class AuditLogComponent implements OnInit {
  entries: AuditEntry[] = [];
  actions: { value: string; label: string }[] = [];
  selectedAction: string | null = null;
  loading = false;
  page = 0;
  size = 20;
  totalElements = 0;

  constructor(private audit: AgencyAuditService, private flag: FlagService) {}

  ngOnInit(): void {
    this.audit.actions().subscribe({
      next: (actions) => (this.actions = actions ?? []),
      error: () => (this.actions = []),
    });
    this.load();
  }

  onActionChange(): void {
    this.page = 0;
    this.load();
  }

  onPage(event: PageEvent): void {
    this.page = event.pageIndex;
    this.size = event.pageSize;
    this.load();
  }

  load(): void {
    this.loading = true;
    this.audit.search(this.page, this.size, this.selectedAction).subscribe({
      next: (res) => {
        this.entries = res?.content ?? [];
        this.totalElements = res?.totalElements ?? 0;
        this.loading = false;
      },
      error: (err) => {
        this.entries = [];
        this.totalElements = 0;
        this.loading = false;
        this.flag.displayFlag(err?.error?.message || "Impossible de charger le journal d'audit.", FlagType.error);
      },
    });
  }

  format(value?: string): string {
    if (!value) {
      return '';
    }
    const d = new Date(value);
    if (isNaN(d.getTime())) {
      return value;
    }
    const pad = (n: number) => (n < 10 ? '0' + n : '' + n);
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }
}
